<template>
  <div>
    <Loader v-if="loading" />
    <div v-else> 
      <div class="container-fluid mt-45">
          <div class="row">
              <div class="col">
                <Breadcrumbs />
              </div>
          </div>

          <div class="row mt-4">
              <div class="col">
                  <div class="card text-sm">
                      <div class="card-body">
                          <h5 class="mb-0">Profile details</h5>
                          
                          <div class="row justify-content-between mt-4">
                              <div class="col-xl-5">
                                  <div class="form-group row">
                                      <label for="title" class="col-sm-3">Title <span class="text-danger">*</span></label>
                                      <div class="col-sm-9">
                                        <select type="text" class="custom-select" id="title" v-model="title">
                                          <option :value="Salutation.MR">Mr</option>
                                          <option :value="Salutation.MRS">Mrs</option>
                                          <option :value="Salutation.MISS">Miss</option>
                                          <option :value="Salutation.MS">Ms</option>
                                          <option :value="Salutation.DR">Dr</option>
                                          <option :value="Salutation.SIR">Sir</option>
                                          <option :value="Salutation.PROFESSOR">Professor</option>
                                        </select>
                                        <small v-if="errors && errors.title" class="text-danger">
                                          {{ errors.title[0] }}
                                        </small>
                                      </div>
                                  </div>

                                  <div class="form-group row">
                                      <label for="first-name" class="col-sm-3">First name <span class="text-danger">*</span></label>
                                      <div class="col-sm-9">
                                        <input type="text" class="form-control" :class="{'border border-danger' : errors && errors.firstName}" id="first-name" v-model="firstName">
                                        <small v-if="errors && errors.firstName" class="text-danger">
                                          {{ errors.firstName[0] }}
                                        </small>
                                      </div>
                                  </div>

                                  <div class="form-group row">
                                      <label for="middle-names" class="col-sm-3">Middle names</label>
                                      <div class="col-sm-9">
                                        <input type="text" class="form-control" id="middle-names" v-model="middleNames">
                                      </div>
                                  </div>

                                  <div class="form-group row">
                                      <label for="surname" class="col-sm-3">Surname <span class="text-danger">*</span></label>
                                      <div class="col-sm-9">
                                        <input type="text" class="form-control" :class="{'border border-danger' : errors && errors.surname}" id="surname" v-model="surname">
                                        <small v-if="errors && errors.surname" class="text-danger">
                                          {{ errors.surname[0] }}
                                        </small>
                                      </div>
                                  </div>

                                  <div class="form-group row">
                                      <label for="phone-no" class="col-sm-3">Phone number <span class="text-danger">*</span></label>
                                      <div class="col-sm-6">
                                        <input type="text" class="form-control" :class="{'border border-danger' : errors && errors.phone}" id="phone-no" v-model="userDetails.phone" readonly>
                                        <small v-if="errors && errors.phone" class="text-danger">
                                          {{ errors.phone[0] }}
                                        </small>
                                      </div>
                                      <div class="col-sm-3 text-right">
                                        <button @click="changePhoneNumber()" class="btn btn-primary btn-form sm-shadow">Change</button>
                                      </div>
                                  </div>

                                  <div class="form-group row">
                                      <label for="email" class="col-sm-3">Email address</label>
                                      <div class="col-sm-9">
                                        <input type="text" class="form-control" id="email" v-model="userDetails.email" readonly>
                                      </div>
                                  </div>

                                  <div class="form-group row">
                                      <label for="speciality" class="col-sm-3">Speciality <span class="text-danger">*</span></label>
                                      <div class="col-sm-9">
                                        <select type="text" class="custom-select" :class="{'border border-danger' : errors && errors.speciality}" id="speciality" v-model="userDetails.speciality">
                                          <option :value="SpecialityType.OBSTETRICIAN">Obstetrician</option>
                                          <option :value="SpecialityType.MIDWIFE">Midwifery</option>
                                          <option :value="SpecialityType.HCA">HCA</option>
                                          <option :value="SpecialityType.NURSE">Nurse</option>
                                          <option :value="SpecialityType.GP">GP</option>
                                          <option :value="SpecialityType.SCC">SCC</option>
                                          <option :value="SpecialityType.OTHER">Other</option>
                                        </select>
                                        <small v-if="errors && errors.speciality" class="text-danger">
                                          {{ errors.speciality[0] }}
                                        </small>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="row mt-4">
              <div class="col">
                  <div class="card text-sm">
                      <div class="card-body">
                          <h5 class="mb-0">User details</h5>
                          
                          <div class="row justify-content-between mt-4">
                              <div class="col-xl-5">
                                  <div class="row">
                                      <div class="col-sm-3">Status</div>
                                      <div class="col-sm-9">{{ userDetails.isActive ? 'Active' : 'Inactive' }}</div>
                                  </div>

                                  <hr>

                                  <div class="row">
                                      <div class="col-sm-3">Facilities</div>
                                      <div class="col-sm-9">
                                        <ul class="list-unstyled d-flex mb-0">
                                          <li v-for="(name, index) in filteredFacilityNames" :key="index" class="mr-2">{{ name }}<span v-if="index < filteredFacilityNames.length - 1">,</span></li>
                                        </ul>
                                      </div>
                                  </div>

                                  <hr>

                                  <div class="row">
                                      <div class="col-sm-3">User created</div>
                                      <div class="col-sm-9">{{ userDetails.dateCreated | moment("dddd, MMMM Do YYYY") }}</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="fixed-bottom bg-white py-25">
        <div class="container-fluid">
          <div class="row">
            <div class="col text-right center-mobile">
                <router-link :to="{name: 'Dashboard'}" class="btn btn-cancel btn-lg px-4 px-sm-5 lg-shadow">Cancel</router-link>
                <button @click="updateUser()" class="btn btn-success btn-lg px-5 lg-shadow ml-2">Save changes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Loader from '../../../Common/components/Loader.vue'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import ChangeUserPhoneNumber from '@/components/modals/ChangeUserPhoneNumberModalComponent.vue'
import Salutation from '../../../Common/enums/Salutation'
import SpecialityType from '../../../Common/enums/SpecialityType'
export default {
  name: 'MyAccount',

  components: {
    Loader,
    Breadcrumbs
  },

  data() {
    return {
      loading: false,
      title: '',
      firstName: '',
      middleNames: '',
      surname: '',
      errors: {},
      ChangeUserPhoneNumber,
      Salutation,
      SpecialityType
    }
  },

  mounted () {
    if (!this.userDetails || this.userDetails.title == null || !this.userDetails.firstName || !this.userDetails.surname) return this.$router.push({ name: 'Dashboard' })
    this.title = this.userDetails.title
    this.firstName = this.userDetails.firstName
    this.middleNames = this.userDetails.middleNames
    this.surname = this.userDetails.surname
  },

  computed: {
    ...mapGetters({
      userDetails: 'UserStore/GetUserDetails',
      organisationId: 'UserStore/GetUserOrganisationId',
      userRoleType: 'UserStore/GetUserRoleType',
      myFacilities: 'FacilityStore/GetMyFacilities'
    }),

    filteredFacilityNames() {
      let names = []

      this.myFacilities.forEach(f => {
        names.push(f.name)
      })

      return names
    },

    facilityIdsComputed() {
      let ids = []

      this.myFacilities.forEach(f => {
        ids.push(f.id)
      })

      return ids
    }
  }, 

  methods: {
    ...mapActions({
      getAllPractitioners: 'PractitionerStore/GetAllPractitioners',
      getUserDetails: 'UserStore/GetPractitionerUserDetails',
      updatePractitionerUserDetails: 'UserStore/UpdatePractitionerUserDetails',
      updateNameInUserStore: 'UserStore/SetUserName',
      setNotification: 'NotificationStore/SetNotification'
    }), 

    changePhoneNumber() {
      this.$modal.show(ChangeUserPhoneNumber, {}, {width: '400px', clickToClose: false})
    },

    async updateUser() {
      this.checkForm()

      if(!Object.keys(this.errors).length) {
        this.loading = true

        let userModel = {
          title: this.title,
          firstName: this.firstName,
          middleNames: this.middleNames,
          surname: this.surname,
          email: this.userDetails.email,
          speciality: this.userDetails.speciality,
          isActive: this.userDetails.isActive,
          facilityIds: this.facilityIdsComputed,
          trainingVersionCompleted: this.userDetails.trainingVersionCompleted,
          trainingCompletedDateTime: this.userDetails.trainingCompletedDateTime,
          isNotificationManager: this.userDetails.isNotificationManager
        }
        
        try {
          await this.updatePractitionerUserDetails({
            organisationId: this.organisationId, 
            userDetails: userModel
          })

          this.updateNameInUserStore({
            title: this.title,
            firstName: this.firstName,
            surname: this.surname
          })

          await this.getAllPractitioners()

          this.setNotification({
            type: 'success',
            title: 'Success',
            message: 'Your account details were updated'
          })
        }
        catch(err) {
          this.setNotification({
            type: 'error',
            title: 'Error',
            message: 'Something went wrong. Please try again'
          })
        }
        finally {
          this.loading = false
        }
      }
    },

    checkForm() {
      this.errors = []

      if(this.userDetails.title == null || this.userDetails.title < 0) {
        this.errors.title = ['Title field is required']
      }

      if(!this.userDetails.firstName) {
        this.errors.firstName = ['First name field is required']
      }

      if(!this.userDetails.surname) {
        this.errors.surname = ['Surname field is required']
      }

      if(this.userDetails.speciality == null || this.userDetails.speciality < 0) {
        this.errors.speciality = ['Speciality field is required']
      }
    }
  }
}
</script>